import { get, post } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  getVideoCallSetupFailed,
  getVideoCallSetupSuccess,
  updateVideoCallSetupFailed,
  updateVideoCallSetupSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import { GET_VIDEO_CALL_SETUP, UPDATE_VIDEO_CALL_SETUP } from "./actionTypes"

function* getVideoCallSetup({ payload: params }) {
  try {
    const response = yield get("/video-call/setup", { params })
    yield put(getVideoCallSetupSuccess(response))
  } catch (error) {
    yield put(getVideoCallSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateVideoCallSetup({ payload: params }) {
  try {
    const response = yield post("/video-call/setup", params)
    yield put(updateVideoCallSetupSuccess(response))
    showToast("success", "Data successfully saved!", "Success")
  } catch (error) {
    yield put(updateVideoCallSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* videoCallSaga() {
  yield takeEvery(GET_VIDEO_CALL_SETUP, getVideoCallSetup)
  yield takeEvery(UPDATE_VIDEO_CALL_SETUP, updateVideoCallSetup)
}

export default videoCallSaga
